import { Navigate, useLocation } from "react-router-dom";

export function HoursOverviewRedirect() {
  const { search, hash, state } = useLocation();
  return <Navigate to={{ pathname: "/dashboard/hours", search, hash }} state={state} replace />;
}
